import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { getOSHData } from '../../../api';
import images from '../../../style/img/flag/images';

class RegulationReport extends Component {
    constructor(props){
        super(props);
        this.state = {
            euData: [],
            country: undefined,
            filters: {                
				countries: [
					{code: 'EU27_2020'}
				]
			},
            isFetching: false
        }
    }

    getData = () => {
        try{
            getOSHData('STRATEGY_REGULATION', this.state.filters)
			.then((res) => {
				const euData = res.resultset;
                if(euData.length > 0){
                    this.setState({
                        euData: euData[0] || [],
                        country: euData[0].country
                    })
                }
			})
        } catch (error) {
            console.log('Error fetching data', error)
        } finally {
            this.setState({ ...this.state, isFetching: false })
        }
    }

    componentDidMount(){
        this.setState({ ...this.state, isFetching: true });
        this.getData();
    }

    render(){
        return (
            <div>
                {
                    this.state.country && (
                        <header>
                            <img className="flag" src={images[this.state.country.code.toLowerCase()]}/>
                            <h2 className="country title-section main-color">{this.props.literals["L"+this.state.country.literalID]}</h2>
                        </header>
                    )
                }
                {
                    this.state.euData && (
                        <React.Fragment>
                            <div className='box-rounded'>
                                <h5>{this.props.literals.L20033}</h5>
                                <div>{ReactHtmlParser(this.props.literals["L"+this.state.euData.text1])}</div>
                            </div>
                            <div className='box-rounded'>
                                <h5>{this.props.literals.L20034}</h5>
                                <div>{ReactHtmlParser(this.props.literals["L"+this.state.euData.text2])}</div>
                            </div>
                            <div className='box-rounded'>
                                <h5>{this.props.literals.L20035}</h5>
                                <div>{ReactHtmlParser(this.props.literals["L"+this.state.euData.text3])}</div>
                            </div>
                            <div className='box-rounded european-standard'>
                                <h5>{this.props.literals.L20036}</h5>
                                <div>{ReactHtmlParser(this.props.literals["L"+this.state.euData.text4])}</div>
                            </div>
                            {/* <div className='break-after'></div> */}
                            <div className='box-rounded'>
                                <h5>{this.props.literals.L20037}</h5>
                                <div>{ReactHtmlParser(this.props.literals["L"+this.state.euData.text5])}</div>
                            </div>
                            <div className='box-rounded'>
                                <h5>{this.props.literals.L20038}</h5>
                                <div>{ReactHtmlParser(this.props.literals["L"+this.state.euData.text6])}</div>
                            </div>
                            <div className='box-rounded court-decisions'>
                                <h5>{this.props.literals.L20039}</h5>
                                <div>{ReactHtmlParser(this.props.literals["L"+this.state.euData.text7])}</div>
                            </div>
                        </React.Fragment>
                    )
                }
            </div>
        )
    }
}

export default RegulationReport;